import React from 'react';

interface MainContentProps {
  children: React.ReactNode;
  variant?: 'frontend' | 'auth' | 'admin';
  className?: string;
}

const MainContent: React.FC<MainContentProps> = ({ 
  children, 
  variant = 'frontend', 
  className = '' 
}) => {
  const getContainerClass = () => {
    switch (variant) {
      case 'auth':
        return 'auth-container';
      case 'admin':
        return 'admin-content';
      default:
        return 'frontend-container';
    }
  };

  return (
    <main className={`${getContainerClass()} ${className}`}>
      {children}
    </main>
  );
};

export default MainContent;
